import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import styles from './style.module.scss';
import { PlusIcon, ProjectNameIcon, StatusCheckIcon, EyeIcon, ShopifyIcon } from 'assets';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import GenericTable from 'shared/components/common/table/table';
import DashboardWrapper from 'shared/components/common/dashboard_wrapper/DashboardWrapper';
import Heading from 'shared/components/common/heading/Heading';
import Switch2 from 'shared/components/common/switch2/Switch2';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import AddClient from 'shared/modal/add_product/AddProduct';
import PurchaseOrderModal from 'shared/modal/purchase_order/PurchaseOrder';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';
import { GetAllPOQuery } from 'shared/services/po_service/POService';
import { GetAllSOQuery } from 'shared/services/so_service/SOService';
import moment from 'moment';
import { isRestrictActions } from 'shared/utils/Helper';
import { screenActionEnum, screenEnum } from 'shared/utils/Enum';
import { routeConstant } from 'shared/routes/RouteConstant';
import ExcelExport from 'shared/components/common/ExcelExport/ExcelExport';
import SearchBar from 'shared/components/common/searchbar/SearchBar';
import PoSearchBar from 'shared/components/common/searchbar/PoSearchBar';
import { wareHouse } from 'shared/utils/Enum';
import Select from 'react-select';
import { GetAllWarehouse } from 'shared/services/ware_house_service/WareHouseService';



const IGNORED_KEYS = new Set(['_id', '__v', 'createdAt', 'updatedAt', 'created_at', 'updated_at', 'po']);

const deepSearchSingleWord = (obj, word) => {
    if (typeof obj === 'string' || typeof obj === 'number') {
        return obj.toString().toLowerCase().includes(word);
    }

    if (Array.isArray(obj)) {
        return obj.some(item => deepSearchSingleWord(item, word));
    }

    if (typeof obj === 'object' && obj !== null) {
        return Object.entries(obj).some(([key, value]) => {
            if (IGNORED_KEYS.has(key)) {
                return false;
            }
            return deepSearchSingleWord(value, word);
        });
    }

    return false;
};

const deepSearch = (obj, searchTerm) => {
    if (!searchTerm) return true;
    
    // Parse search terms supporting quoted phrases
    const regex = /"([^"]+)"|'([^']+)'|(\S+)/g;
    const words = [];
    let match;
    while ((match = regex.exec(searchTerm)) !== null) {
        const token = match[1] || match[2] || match[3];
        if (token) {
            words.push(token.toLowerCase());
        }
    }

    if (words.length === 0) return true;
    return words.every(word => deepSearchSingleWord(obj, word));
};

export default function SaleOrder() {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);
    const [searchMenu, setsearchMenu] = useState('');
    const [clicksearch, setClickSearch] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [wareHouses, setWareHouses] = useState([]);
    const [selectedWarehouse, setSelectedWarehouse] = useState();

    const obj = {};
    if (clicksearch) {
        obj['search'] = clicksearch;
    }
    const queryObj = {};
    if (selectedWarehouse?.value) queryObj.warehouseId = selectedWarehouse.value;
    const queryString = new URLSearchParams(queryObj).toString();

    const { isLoading, data: SoList, isError, error, isSuccess } = GetAllSOQuery(queryString);
    const { data: listWareHouse } = GetAllWarehouse();

    console.log(listWareHouse, "selectedWarehouse");


    const SearchBars = (customSearchTerm) => {
        const term = customSearchTerm !== undefined ? customSearchTerm : searchMenu;
        if (term.length > 0) {
            const filteredData = SoList.filter((item) => deepSearch(item, term));
            setSearchResults(filteredData);
        } else {
            setSearchResults(SoList);
        }
    };
    useEffect(() => {
        const wareHouseoptions = (listWareHouse || []).map((w) => ({
            ...w,
            label: w?.code,
            value: w?._id,
        }));
        setWareHouses(wareHouseoptions);

        if (!isSuccess || !SoList) return;
        // handle data array (safe check)
        const soArray = Array.isArray(SoList)
            ? SoList
            : Array.isArray(SoList.data)
                ? SoList.data
                : [];

        // har SO me amount calculate krna (assuming pricing is handled similarly or showing N/A)
        soArray.forEach(so => {
            const totalAmount = (so.order || []).reduce((acc, order) => {
                const price = Number(order.price) || 0;
                const qty = Number(order.quantity) || 0;
                return acc + price * qty;
            }, 0);

            so.amount = totalAmount;
        });

        if (SoList.data) {
            SoList.data = soArray;
        }
    }, [SoList, isSuccess]);

    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [openProduct, setOpenProduct] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const toggleEditUser = () => {
        setIsEdit(!isEdit);
    };
    useEffect(() => {
        if (SoList) {
            setSearchResults(SoList);
        }
    }, [SoList]);
    const navigateToPath = () => {
        navigate(routeConstant.admin.so.addso.path);
    };
    const views = (data) => {
        navigate(routeConstant.admin.so.viewso.path, { state: { data } });
    };
    const closeProductHandler = () => setOpenProduct(false);
    const formatPrice = (price) => {
        const num = Number(price);
        if (isNaN(num)) return 'Rs 0.00';
        return `${num.toFixed(2)}`;
    };

    const columns = React.useMemo(
        () => [
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Order#
                    </div>
                ),
                accessor: 'order_number',
                Cell: ({ row }) => (
                    <div style={{ position: 'relative', display: 'inline-block' }}>
                        {row.original?.shopify && (
                            <div style={{ position: 'absolute', right: '100%', marginRight: '8px', top: '50%', transform: 'translateY(-50%)' }}>
                                <ShopifyIcon
                                    width="20"
                                    height="20"
                                    title="Shopify Order"
                                />
                            </div>
                        )}
                        <span>{row.original?.order_number}</span>
                    </div>
                )
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Issue Date
                    </div>
                ),
                accessor: 'created_at',
                Cell: ({ row }) => <div>{moment(row.original?.updated_at).format('DD, MMM YYYY')}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Supplier
                    </div>
                ),
                accessor: 'supplier',
                Cell: ({ row }) => <div>{row.original?.shipping?.customerName || row.original?.supplier?.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Total Amout
                    </div>
                ),
                accessor: 'amount',
                Cell: ({ row }) => <div>{formatPrice(row.original?.amount)}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <StatusCheckIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        View & Print
                    </div>
                ),
                accessor: 'view&print',
                Cell: ({ row }) => <EyeIcon onClick={() => views(row?.original)} style={{ cursor: 'pointer' }} />
            }
        ],

        [theme, showModal]
    );

    return (
        <DashboardWrapper>
            <div className={classNames(styles.UserContainer, 'text-start')}>
                <PoSearchBar setsearchMenu={setsearchMenu} searchMenu={searchMenu} suggestionsSource={SoList} SearchBars={SearchBars} />
                <div className={styles.Header}>
                    <Heading heading={'Sale Order'} headingStyle={styles.Heading} />
                    <div className={styles.HeaderActions}>
                        <Select
                            placeholder="Filter by Warehouse"
                            isClearable
                            options={wareHouses}
                            value={selectedWarehouse}
                            onChange={(item) => setSelectedWarehouse(item)}
                            menuPortalTarget={document.body}
                            styles={{
                                control: (provided, state) => ({
                                    ...provided,
                                    minWidth: 220,
                                    height: '40px',
                                    minHeight: '40px',
                                    borderRadius: '6px',
                                    border: state.isFocused ? '1px solid #4a86f7' : '1px solid #c9d1e1',
                                    boxShadow: state.isFocused ? '0 0 0 1px #4a86f7' : 'none',
                                    '&:hover': { border: '1px solid #4a86f7' },
                                    cursor: 'pointer',
                                }),
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                        />
                        <CustomButton
                            Icon={PlusIcon}
                            submitHandle={() => {
                                if (isRestrictActions(screenEnum.so, screenActionEnum.create)) {
                                    navigateToPath();
                                }
                            }}
                            IconStyle={classNames('me-1', styles.IconStyle)}
                            text={'Sale Order'}
                            containerStyle={classNames(styles.AddProduct)}
                        />
                        <ExcelExport data={SoList} fileName={'Sale Order'} />
                    </div>
                </div>
                <GenericTable columns={columns} data={searchResults || []} TableWrapperStyle={classNames(styles.Table)} />
                <AddClient show={openProduct} handleClose={closeProductHandler} />
            </div>
            {isLoading && <OverlayLoading />}
        </DashboardWrapper>
    );
}
